module.exports = __webpack_public_path__ + "img/bot.1708ff65.svg";